<template>
	<div>
		<template v-if="true">
			<!-- authStore.authReady -->
			<!-- Your app content -->

			<router-view></router-view>
		</template>
		<template v-else>
			<!-- Loading state -->
			<div class="flex justify-center items-center min-h-screen">
				<span class="loading loading-spinner loading-lg"></span>
			</div>
		</template>
	</div>
</template>

<script setup>
//import { useAuthStore } from "@/stores/auth";
//const authStore = useAuthStore();
</script>
